// removed by extract-text-webpack-plugin
module.exports = {"toggle":"_2lChr","selected":"_3MRMF"};


//////////////////
// WEBPACK FOOTER
// ./components/Toggle.css
// module id = 1242
// module chunks = 0 3 5